import { Injector, ProviderToken } from '@angular/core';

let appInjector: Injector | null = null;

export function setAppInjector(injector: Injector): void {
  appInjector = injector;
}

export function getFromInjector<T>(token: ProviderToken<T>): T {
  if (!appInjector) {
    throw new Error('App injector has not been set yet.');
  }

  return appInjector.get(token);
}
